module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-page",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "col-12 page-title"
  }, [_vm._v("\n      NOUS CONTACTER\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-9 section-title",
    attrs: {
      "id": "contact-content"
    }
  }, [_c('h1', {
    staticClass: "pb-1"
  }, [_vm._v("Nous contacter directement")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('v-form', {
    ref: "form",
    staticClass: "row",
    attrs: {
      "id": "email-form",
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid_form),
      callback: function($$v) {
        _vm.valid_form = $$v
      },
      expression: "valid_form"
    }
  }, [_c('v-text-field', {
    staticClass: "col-12",
    attrs: {
      "rules": _vm.rules.name,
      "label": "Nom / Prénom",
      "required": ""
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "col-12",
    attrs: {
      "rules": _vm.rules.email,
      "label": "Adresse email",
      "required": ""
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "col-12",
    attrs: {
      "rules": _vm.rules.phone,
      "label": "Téléphone",
      "required": ""
    },
    model: {
      value: (_vm.form.phone_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone_number", $$v)
      },
      expression: "form.phone_number"
    }
  }), _vm._v(" "), _c('v-textarea', {
    staticClass: "col-12 mt-5",
    attrs: {
      "rules": _vm.rules.text_long,
      "label": "Votre message",
      "auto-grow": true,
      "clearable": true,
      "counter": true,
      "loading": _vm.loading,
      "outlined": true,
      "placeholder": "Écrivez ici votre message au Dr SAAD Ryan !",
      "rounded": true,
      "solo": true,
      "required": ""
    },
    model: {
      value: (_vm.form.message),
      callback: function($$v) {
        _vm.$set(_vm.form, "message", $$v)
      },
      expression: "form.message"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "id": "sendButton",
      "disabled": !_vm.valid_form,
      "color": "success"
    },
    on: {
      "click": _vm.validate_form
    }
  }, [_vm._v("\n              Envoyer le formulaire\n            ")])], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-3 pb-5 section-title text-left"
  }, [_c('h2', {
    staticClass: "pb-1"
  }, [_vm._v("Dr SAAD Ryan")]), _vm._v(" "), _c('div', [_vm._v("\n            29 Rue Sarrette, 75014 Paris\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n            Rdv par téléphone : "), _c('span', {
    attrs: {
      "href": "tel:0156535858"
    }
  }, [_vm._v("01 56 53 58 58")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-3"
  }, [_vm._v("\n          Vous êtes un "), _c('b', [_vm._v("patient")]), _vm._v(", un "), _c('b', [_vm._v("confrère médecin ou dentiste")]), _vm._v(" souhaitant nous contacter pour un patient ou une formation ? "), _c('b', [_vm._v("Cette rubrique est faite pour vous !")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-3"
  }, [_vm._v("\n          Le contact par cette rubrique vous permet d'"), _c('b', [_vm._v("éviter l'attente du téléphone")]), _vm._v(". Le site permet au public d'envoyer des "), _c('b', [_vm._v("courriers électroniques")]), _vm._v(" au praticien. Nous nous engageons à y répondre et à ne pas collecter les adresses d'expéditeurs ou leur transmission à des tiers.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pt-3"
  }, [_vm._v("\n          Nous vous encourageons à préférer ce mode de communication ! Nous vous "), _c('b', [_vm._v("répondrons dans les plus brefs délais")]), _vm._v(".\n        ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c7d2c3c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c7d2c3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/views/pages/contact/contact.component.html
// module id = 259
// module chunks = 1